<template>
  <div class="page-container">
    <div class="head">
      <div>轮播图列表</div>
      <div><el-button type="primary"
                   @click="onAdd"
                   size="medium">新增</el-button>

      </div>
    </div>
    <!--表格内容栏-->
    <el-table :data="tabData"
              border
              style="width: 100%">
      <el-table-column type="index"
                       align="center">
      </el-table-column>
      <el-table-column prop="title"
                       label="标题"
                       align="center">
      </el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       align="center"
                       width="220">
        <template slot-scope="scope">
          <el-button size="mini"
                     @click="handleView(scope.$index, scope.row)">预览</el-button>
          <el-button size="mini"
                     @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini"
                     type="danger"
                     @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增编辑界面-->
    <el-dialog :title="title"
               :visible.sync="dialogVisible"
               width="30%"
               @close="coloseDialog">
      <div>
        <el-form ref="form"
                 :model="form"
                 label-width="100px">
          <el-form-item label="标题">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="banner图片">
            <el-upload class="upload-demo"
                       style="text-align: left;"
                       ref="upload"
                       action="https://xkbd.net/api/common/file"
                       :headers="headerInfo"
                       :auto-upload="true"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove"
                       :on-success="handleAvatarSuccess"
                       :on-change="handleChange"
                       :file-list="fileList"
                       list-type="picture">
              <el-button size="small"
                         type="primary">点击上传</el-button>

            </el-upload>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-radio-group v-model="form.isEnabled">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="详情URL">
            <el-upload class="upload-demo"
                       style="text-align: left;"
                       ref="upload2"
                       action="https://xkbd.net/api/common/file"
                       :auto-upload="true"
                       :headers="headerInfo"
                       :on-preview="handlePreview2"
                       :on-remove="handleRemove2"
                       :on-success="handleAvatarSuccess2"
                       :on-change="handleChange2"
                       :file-list="fileList2"
                       list-type="picture">
              <el-button size="small"
                         type="primary">点击上传</el-button>

            </el-upload>
          </el-form-item>
          <el-form-item label="内容">
            <el-input type="textarea"
                      v-model="form.content"
                      :rows="4"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false"
                   size="medium">取 消</el-button>
        <el-button type="primary"
                   @click="handleSave"
                   size="medium">{{this.title == '修改'?'修 改':'保 存'}}</el-button>
      </span>
    </el-dialog>
    <!-- 预览 -->
    <el-dialog title="预览"
               :visible.sync="dialogVisible2"
               width="30%"
               @close="coloseDialog">
      <div>
        <el-form ref="form"
                 :model="form"
                 label-width="80px">
          <el-form-item label="标题">
            <span>{{form.title}}</span>
          </el-form-item>
          <el-form-item label="banner">
            <template v-if="form.banner">
              <el-image style="width: 100px; height: 80px"
                        v-if="form.banner.includes('jpg')||form.banner.includes('jpeg')||form.banner.includes('png')||form.banner.includes('PNG')||form.banner.includes('JPEG')||form.banner.includes('JPG')"
                        :src="form.banner"
                        :preview-src-list="[form.banner]"></el-image>
              <el-button type="text"
                         @click="openVideo(form.banner)"
                         v-else>查看</el-button>
            </template>
            <span v-else>-</span>
          </el-form-item>
          <el-form-item label="URL">
            <!-- <el-button type="text" @click="openVideo(form.url)">查看</el-button> -->
            <template v-if="form.url">
              <el-image style="width: 100px; height: 80px"
                        v-if="form.url.includes('jpg')||form.url.includes('jpeg')||form.url.includes('png')||form.url.includes('PNG')||form.url.includes('JPEG')||form.url.includes('JPG')"
                        :src="form.url"
                        :preview-src-list="[form.url]"></el-image>
              <el-button type="text"
                         @click="openVideo(form.url)"
                         v-else>查看</el-button>
            </template>
            <span v-else>-</span>

          </el-form-item>
          <el-form-item label="内容">
            <span>{{form.content}}</span>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible2= false"
                   size="medium">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { format } from "@/utils/datetime"
import Cookies from "js-cookie";
export default {
  components: {
  },
  data () {
    return {
      headerInfo: {
        Authorization: Cookies.get('token')
      },
      filters: {},
      size: "small",
      tabData: [],
      dialogVisible: false,
      dialogVisible2: false,
      title: "新增",
      form: {
        title: "",
        isEnabled: 1,
        banner: "",
        url: "",
        content: ""
      },
      fileList: [],
      fileList2: [],
      pamas: {
        pageNum: 1,
        pageSize: "10"
      }
    }
  },
  mounted () {
  },
  created () {
    this.getBananerList()
  },
  methods: {
    openVideo (url) {
      window.open(url, '预览', '', false)
    },
    getBananerList () {
      this.$api.bananer.getList(this.pamas).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          this.tabData = res.data.list
        }
      })
    },
    onAdd () {
      this.title = '新增'
      this.dialogVisible = true
    },
    //bannner
    handleChange (file, fileList) {
      console.log(file, fileList, 'cghange')
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
      }
    },
    //url
    handleChange2 (file, fileList) {
      console.log(file, fileList, 'cghange')
      if (fileList.length > 0) {
        this.fileList2 = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
      }
    },
    // uploadHttpRequest (param) {
    //   const formData = new FormData()
    //   formData.append('file', param.file)
    //   console.log(formData, 'formData')
    //   this.$api.upload.uploadApi(formData).then((res) => {
    //     if (res.code != 200) {
    //       this.$message({
    //         message: res.message,
    //         type: 'error'
    //       })
    //     } else {
    //       this.form.banner = res.data.fileUrlPath
    //     }
    //   })

    // },
    // uploadHttpRequest2 (param) {
    //   const formData = new FormData()
    //   formData.append('file', param.file)
    //   console.log(formData, 'formData')
    //   this.$api.upload.uploadApi(formData).then((res) => {
    //     if (res.code != 200) {
    //       this.$message({
    //         message: res.message,
    //         type: 'error'
    //       })
    //     } else {
    //       this.form.url = res.data.fileUrlPath
    //     }
    //   })

    // },
    handleSave () {
      if (this.form.id) {
        this.handleUpdate()
        return
      }
      this.$api.bananer.addApi(this.form).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          this.$message.success('新增成功')
          this.dialogVisible = false
          this.reasetForm()
          this.getBananerList()
        }
      })
    },
    handleUpdate () {
      this.$api.bananer.updateApi(this.form).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        } else {
          this.$message.success('更新成功')
          this.dialogVisible = false
          this.reasetForm()
          this.getBananerList()
        }
      })
    },
    coloseDialog () {
      this.reasetForm()
    },
    //重置表格
    reasetForm () {

      this.form.banner = ""
      this.form.content = ""
      this.form.isEnabled = 1
      this.form.title = ""
      this.form.url = ""
      this.fileList = []
      this.fileList2 = []
      if (this.form.id) {
        delete this.form.id
      }
    },
    handleAvatarSuccess (res, file) {
      console.log(res, file, 'res, file');
      this.form.banner = res.data.fileUrlPath
    },
    handleAvatarSuccess2 (res, file) {
      console.log(res, file, 'res, file');
      this.form.url = res.data.fileUrlPath
    },
    handlePreview (file) {
      console.log(file, 'pre');
    },
    handleRemove (file) { },
    handlePreview2 (file) {
      console.log(file, 'pre');
    },
    handleRemove2 (file) { },
    handleDelete (index, item) {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        // 用户点击确认
        this.$api.bananer.deleteApi(item.id).then((res) => {
          if (res.code != 200) {
            this.$message({
              message: res.message,
              type: 'error'
            })
          } else {
            this.$message.success('删除成功')
            this.getBananerList()
          }
        })
      }).catch(() => {
        // 用户点击取消
        console.log('取消操作');
      });

    },
    //预览
    handleView (index, item) {
      this.dialogVisible2 = true
      this.form = JSON.parse(JSON.stringify(item))
    },
    //编辑
    handleEdit (index, item) {
      console.log(item, 'item')
      this.dialogVisible = true
      this.title = '修改'
      this.form = JSON.parse(JSON.stringify(item))
      if (item.banner) {
        this.fileList.push({ url: item.banner })
      }
      if (item.url) {
        this.fileList2.push({ url: item.url })
      }
    },
  },
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__header {
  text-align: left;
}
.head {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/views/BannerMange/BannerMange.vue